import styled from 'styled-components';

export const HeaderDiv = styled.div`
  align-items: center;
  background-color: var(--color-gris);
  display: flex;
  flex-direction: column;
  font-family: 'Bell MT', Arial;
  min-height: var(--header-min-height);
  padding: 5px 0 5px;
  position: sticky;
  top: 50px;
  z-index: 1;
`;

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 5px 10px;
  width: 100%;
`;

export const LogoContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const LogoImg = styled.img`
  width: 80%;
`;

export const ArrowContainer = styled.div`
  cursor: pointer;
`;